// Gemeinsame Helfer für die Buchhaltung-Untermodule.
export const fmtDate = (iso) => {
    try { return new Date(iso).toLocaleDateString("de-DE"); } catch { return iso || "—"; }
};
